import { render, staticRenderFns } from "./partner-list.vue?vue&type=template&id=7b519060&scoped=true&"
import script from "./partner-list.vue?vue&type=script&lang=js&"
export * from "./partner-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b519060",
  null
  
)

export default component.exports